import React from 'react'
import './about.scss'
import { httpOperations, clientUrl } from '../../services/httpOperations'
import Typed from 'typed.js';
export const About = () => {

  const typed = React.useRef(null);
  const el = React.useRef(null);
  React.useEffect(() => {
    const options = {
      strings: ['MERN stack developer'],
      typeSpeed: 50,
      backSpeed: 40,
      backDelay: 1000,
      // smartBackspace: true, // this is a default
      loop: true,
      fadeout: true
    };

    // elRef refers to the <span> rendered below
    typed.current = new Typed(el.current, options);

    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.current.destroy();
    }
  }, [])

  return (
    <section class="about" id="about">
      <div class="max-width">
        <h2 class="title">About me</h2>
        <div class="about-content">
          <div class="column left">
            <img src="images/profilepic1.jpg" alt="" />
          </div>
          <div class="column right">
            <div class="text">
              I'm Rathish and I'm a <span ref={el}></span>
            </div>
            <p>Innovative optimized solution seeker. Excited to be at deployment phase of my new career as a web developer. Dedicated and efficient full stack developer and have developed some real time applications. I am a highly self motivated web developer who spends most of the time developing code in latest technologies.</p>
            <a href={clientUrl + "cv"}>Download CV</a>
          </div>
        </div>
      </div>
    </section>
  )
}
